<template>
  <el-col :span="16" class="experienceMain">
    <el-row v-for="(item, index) in xdList" :key="index">
      <popoverinfo ref="refpopover" :avatar="item.avatr" :baseinfo="baseinfo" @goToda="goToda"></popoverinfo>
      <el-col :span="24">
        <el-row>
          <el-col :span="2">
            <img :src="item.avatr || '/base/images/layout/user.png'" alt="item.xm" class="avatrimg"
              @click="gotomyself(item)" @mouseover="getpopoverinfo(item,index)">
          </el-col>
          <el-col :span="22">
            <el-row>
              <el-col :span="24">
                <div class="name">
                  {{item.xm}}
                </div>
                <div class="department">
                  {{item.txrq}} {{item.orgName}}
                </div>
              </el-col>
              <el-col :span="24">
                <div class="content">
                  {{item.xd}}
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="23">
            <el-col :span="21">&nbsp;</el-col>
            <el-col :span="3" class="comment_on">
              <div @click="discuss(index, item)">
                <span class="count_active" v-if="activeIndex===index"><img
                    src="/base/images/expression/comment_active.png" alt=""> {{item.plNum}}</span>
                <span v-else><img src="/base/images/expression/comment.png" alt=""> {{item.plNum}}</span>
              </div>
              <div @click="sendFlowers(index, item)">
                <span class="count_active" v-if="item.dzid !== null"><img src="/base/images/expression/hua_active.png"
                    alt=""> {{item.zdNum}}</span>
                <span v-else><img src="/base/images/expression/hua.png" alt=""> {{item.zdNum}}</span>
              </div>
            </el-col>
          </el-col>
        </el-row>
        <el-row v-show="activeIndex===index">
          <el-col :span="2">&nbsp;</el-col>
          <el-col :span="22">
            <el-input type="textarea" :rows="5" placeholder="发布你的评论" v-model="content">
            </el-input>
            <div class="comment_on_btn">
              <span class="pointer" @click="showEmotion(index, item)">
                <img src="/base/images/expression/expression.png" width="24px" alt="">
              </span>
              <span>
                <el-button type="warning" round size="mini" @click="submitComment(item)">评论</el-button>
              </span>
            </div>
            <emotion @emotion="handleEmotion" :height="200" v-show="emotionIndex===index" class="emotionDiv"></emotion>
          </el-col>

          <el-col :span="2">&nbsp;</el-col>
          <el-col :span="22">
            <el-divider></el-divider>
          </el-col>

          <el-col :span="2">&nbsp;</el-col>
          <el-col :span="22" class="ly_div">
            <div>
              <span class="ly">
                全部留言
              </span>
              <span>
                {{ly.lyCount}}
              </span>
            </div>
          </el-col>

          <el-col :span="2">&nbsp;</el-col>
          <el-col :span="22">
            <el-row v-for="(item, index) in ly.lyList" :key="index">
              <el-col :span="2">
                <img :src="item.avatr || '/base/images/layout/user.png'" width="34px" alt="">
              </el-col>
              <el-col :span="22">
                <el-col :span="23">
                  <div class="ly_name">
                    <font>{{item.commentUserName}}</font>：
                    <span v-html="item.content.replace(/\#[\u4E00-\u9FA5]{1,3}\;/gi, emotion)"></span>
                    <span v-if="item.deleteComment === true" @click="del(item)" class="delbtn"><i
                        class="el-icon-delete"></i>删除</span>
                  </div>
                  <div class="department">
                    {{item.commentTime}}
                  </div>
                </el-col>
              </el-col>
            </el-row>
            <el-col :span="24" class="pl_page_info" v-show="isLyFyShow">
              <el-pagination small layout="prev, pager, next" :total="lyPageInfo.total" :page-size=5
                :hide-on-single-page='true' @current-change="lyHandleCurrentChange" @prev-click="lyPrev"
                @next-click="lyNext">
              </el-pagination>
            </el-col>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <div class="fy" v-show="isFyShow">
      <el-pagination background layout="prev, pager, next" :hide-on-single-page='true'
        @current-change="handleCurrentChange" @prev-click="prev" @next-click="next" :total="pageInfo.total">
      </el-pagination>
    </div>
    <el-dialog :title="dangan.title" :visible.sync="dangan.dialogVisible" width="60%" top="5vh"
      :before-close="handleClose">
      <danganView :loginName='dangan.loginName' :baseinfo="baseinfo" />
    </el-dialog>
  </el-col>
</template>

<script>
import Emotion from '@/portal/base/Experience/Emotion/index'
import danganView from './danganDialog.vue'
import popoverinfo from './popoverinfo'
export default {
  name: 'ExperienceMain',
  props: ['experienceMain'],
  components: {
    Emotion, popoverinfo, danganView
  },
  data() {
    return {
      baseallinfo: {},
      baseinfo: {},
      delbtn: false,
      index: 0,
      emotionIndex: -1,
      imgArr: [],
      yourCommentOn: '',
      content: '',
      comment: '',
      activeIndex: -1,
      flowersIndex: -1,
      isFyShow: false,
      isLyFyShow: false,
      xdId: '',
      xdList: [],
      ly: {
        lyCount: 0,
        lyList: []
      },
      pageInfo: {
        total: 0
      },
      lyPageInfo: {
        total: 0
      },
      sjh: '',
      dangan: {
        loginName: '',
        dialogVisible: false,
        title: '档案'
      }
    }
  },

  mounted() {
    this.getXdQuery({ pageNum: 1, pageSize: 10 })
    this.$http.post('/fighter-apis-manage/apis/query/apis-1703123256305').then(res => {
      this.baseallinfo = res.data
    })
  },
  methods: {
    goToda(data) {
      this.dangan.loginName = data.loginName
      this.dangan.dialogVisible = data.type
      this.dangan.title = data.name + '的个人档案'
      // console.log(data)
    },
    getpopoverinfo(item, index) {
      console.log(item)
      this.baseinfo = this.baseallinfo.filter(e => e.loginName === item.sjh)[0] || ''
      this.$refs.refpopover[index].$refs.refpopover.doShow()
    },
    getXdQuery(pageInfo) {
      this.$http.post('/fighter-lightportal-saas/vBbXrblc/query',
        {
          entity: {
            sjh: this.experienceMain.sjh || ''
          },
          orderItemList: [{ asc: false, column: 'txrq' }, { asc: false, column: 'lastUpdateTime' }, { asc: false, column: 'createTime' }],
          pageNum: pageInfo.pageNum,
          pageSize: pageInfo.pageSize
        }).then(res => {
          console.log(this.experienceMain)
          this.xdList = res.data.records
          this.pageInfo.total = res.data.total
          this.isFyShow = true
          this.$emit('xdTotal', res.data.total)
        }).catch(error => {
          this.$message.error(error.msg)
        })
    },

    getLyQuery(id, pageInfo) {
      this.xdId = id
      this.$http.post('/fighter-lightportal-saas/tExperienceComment/query',
        {
          entity: { composeId: id },
          orderItemList: [
            {
              'asc': false,
              'column': 'commentTime'
            }
          ],
          pageNum: pageInfo.pageNum,
          pageSize: pageInfo.pageSize
        }).then(res => {
          this.ly.lyList = res.data.records

          this.lyPageInfo.total = res.data.total
          this.ly.lyCount = res.data.total
          this.isLyFyShow = true
        }).catch(error => {
          this.$message.error(error.msg)
        })
    },
    prev(pageNum) {
      this.getXdQuery({ pageNum: pageNum, pageSize: 10 })
    },
    next(pageNum) {
      this.getXdQuery({ pageNum: pageNum, pageSize: 10 })
    },
    handleCurrentChange(pageNum) {
      this.getXdQuery({ pageNum: pageNum, pageSize: 10 })
    },

    lyPrev(pageNum) {
      this.getLyQuery(this.xdId, { pageNum: pageNum, pageSize: 5 })
    },
    lyNext(pageNum) {
      this.getLyQuery(this.xdId, { pageNum: pageNum, pageSize: 5 })
    },
    lyHandleCurrentChange(pageNum) {
      this.getLyQuery(this.xdId, { pageNum: pageNum, pageSize: 5 })
    },

    discuss(index, item) {
      console.log(index)
      this.getLyQuery(item.id, { pageNum: 1, pageSize: 5 })
      this.content = ''
      this.activeIndex = this.activeIndex == index ? -1 : index
      // this.flag = !this.flag;
    },
    showEmotion(index, item) {
      this.index = index
      this.emotionIndex = this.emotionIndex == index ? -1 : index
    },
    submitComment(item) {
      if (this.content) {
        let tExperienceComment = {
          'composeId': item.id,
          'content': this.content
        }
        let id = item.id
        this.emotionIndex = -1
        let that = this
        that.$http.post('/fighter-lightportal-saas/tExperienceComment/saveOrUpdate', tExperienceComment).then(res => {
          that.$message.success('评论成功')
          that.getLyQuery(id, { pageNum: 1, pageSize: 5 })
          that.getXdQuery({ pageNum: 1, pageSize: 10 })
        }).catch(res => {
          that.$message.error(res.msg)
        })
      } else {
        this.$message.warning('评论为空,请填写!')
      }
      this.content = ''
    },
    sendFlowers(index, item) {
      if (item.dzid !== null) {
        this.$http.delete('/fighter-lightportal-saas/tExperienceZan/delete', {
          params: {
            idList: item.dzid
          }
        }).then(response => {
          this.flowersIndex = this.flowersIndex === index ? -1 : index
          this.$message.success('取消点赞成功')
          this.getXdQuery({ pageNum: 1, pageSize: 10 })
        }).catch(response => {
          this.$message.error(response.msg)
        })
      } else {
        let tExperienceZan = {
          type: '1',
          typeId: item.id
        }
        this.$http.post('/fighter-lightportal-saas/tExperienceZan/saveOrUpdate', tExperienceZan).then(res => {
          this.flowersIndex = this.flowersIndex == index ? -1 : index
          this.$message.success('点赞成功')
          this.getXdQuery({ pageNum: 1, pageSize: 10 })
        }).catch(res => {
          this.$message.warning(res.msg)
        })
      }

      //  this.flowersIndex = this.flowersIndex == index ? -1 : index;
    },
    handleEmotion(i) {
      this.content = this.content + i
    },
    // 将匹配结果替换表情图片
    emotion(res) {
      let word = res.replace(/\#|\;/gi, '')
      const list = ['微笑', '撇嘴', '色', '发呆', '得意', '流泪', '害羞', '闭嘴', '睡', '大哭', '尴尬', '发怒', '调皮', '呲牙', '惊讶', '难过', '酷', '冷汗', '抓狂', '吐', '偷笑', '可爱', '白眼', '傲慢', '饥饿', '困', '惊恐', '流汗', '憨笑', '大兵', '奋斗', '咒骂', '疑问', '嘘', '晕', '折磨', '衰', '骷髅', '敲打', '再见', '擦汗', '抠鼻', '鼓掌', '糗大了', '坏笑', '左哼哼', '右哼哼', '哈欠', '鄙视', '委屈', '快哭了', '阴险', '亲亲', '吓', '可怜', '菜刀', '西瓜', '啤酒', '篮球', '乒乓', '咖啡', '饭', '猪头', '玫瑰', '凋谢', '示爱', '爱心', '心碎', '蛋糕', '闪电', '炸弹', '刀', '足球', '瓢虫', '便便', '月亮', '太阳', '礼物', '拥抱', '强', '弱', '握手', '胜利', '抱拳', '勾引', '拳头', '差劲', '爱你', 'NO', 'OK', '爱情', '飞吻', '跳跳', '发抖', '怄火', '转圈', '磕头', '回头', '跳绳', '挥手', '激动', '街舞', '献吻', '左太极', '右太极']
      let index = list.indexOf(word)
      return `<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/${index}.gif" align="middle">`
    },
    del(item) {
      this.$http.delete('/fighter-lightportal-saas/tExperienceComment/delete', {
        params: {
          idList: item.id
        }
      }).then(response => {
        this.getLyQuery(this.xdId, { pageNum: 1, pageSize: 5 })
        this.getXdQuery({ pageNum: 1, pageSize: 10 })
        this.$message.success('删除成功')
      }).catch(response => {
        this.$message.error(response.msg)
      })
    },
    gotomyself(item) {
      console.log(item)
      this.$emit('experienceTopData', item)
      this.$emit('experienceMainData', item)
      this.getXdQuery({ pageNum: 1, pageSize: 10 })
    }

  }
}
</script>

<style lang="scss" scoped>
.container {
  margin: 0 auto;
  margin-top: 20px;
  width: 400px;
}
.text {
  display: block;
  margin: 0 auto;
  margin-bottom: 10px;
  width: 400px;
  resize: none;
  box-sizing: border-box;
  padding: 5px 10px;
  border-radius: 8px;
}
.text-place {
  height: 80px;
  box-sizing: border-box;
  padding: 5px 10px;
  border-radius: 8px;
  background: #ddd5d5;
}
.text-place p {
  display: flex;
  align-items: center;
  margin: 0;
}
.avatrimg {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: pointer;
}
.experienceMain > .el-row {
  background-color: white;
  padding: 15px;
  border-bottom: 10px solid #f8f8f8;
  margin-bottom: 0;
}
.experienceMain > .el-row:last-child {
  border-bottom: 0 !important;
}
.experienceMain {
  :deep(.el-col-1) {
    width: 6%;
  }
  :deep(.el-col-23) {
    width: 94%;
    margin-bottom: 0;
  }
  // background-color: white;
  margin-top: 10px;
  // padding: 15px;
  box-sizing: border-box;
  .name {
    font-size: 18px;
  }
  .department {
    color: #808080;
    font-size: 14px;
    margin-top: 2px;
  }
  .content {
    line-height: 2;
    font-size: 16px;
  }
  .margin_tp {
    margin-top: 40px;
  }
  .reading_count {
    margin-bottom: 0;
    div {
      float: right;
      border: 1px solid #f1f1f1;
      width: 80px;
      text-align: center;
      font-size: 12px;
      color: #808080;
      padding-top: 2px;
      p {
        margin-bottom: 2px;
        margin-top: 0;
      }
      p:first-child {
        color: black;
        font-size: 13px;
      }
    }
  }
  .xd_img_div {
    display: none;
    margin-bottom: 4px;
    img {
      width: 98%;
      height: 130px;
      border-radius: 5px;
    }
  }
  .comment_on {
    // font-size: 12px;
    display: flex;
    justify-content: space-around;
    color: #808080;
    img {
      width: 18px;
      vertical-align: middle;
    }
    span {
      cursor: pointer;
    }
    > span:last-child {
      float: right;
    }
  }
  .comment_on_btn {
    margin-top: 15px;
    span:last-child {
      float: right;
    }
  }
  .ly_div {
    margin-bottom: 20px;
    .ly {
      font-size: 15px;
    }
  }

  .ly_name {
    font-size: 13px;
    margin-bottom: 4px;
    font {
      color: #1871db;
    }
    img {
      vertical-align: middle;
      margin-top: -5px;
    }
  }
  .pointer {
    cursor: pointer;
  }

  .emotionDiv {
    height: 200px;
    position: absolute;
    background-color: white;
    z-index: 999;
    width: 94%;
    margin-top: 12px;
  }
  .count_active {
    color: orange;
  }
  .fy,
  .pl_page_info {
    background-color: white;
    padding: 20px;
    text-align: center;
  }
  .delbtn {
    cursor: pointer;
    color: #1871db;
    float: right;
  }
}
</style>
